import React from "react";
import Container from "../common/Container";

const clients = [
  { name: "NovaStack", className: "font-semibold tracking-wide" },
  { name: "Cloudnest Labs", className: "font-serif italic" },
  { name: "PixelForge", className: "font-bold uppercase tracking-widest" },
  { name: "DataCrest", className: "font-medium" },
  { name: "BrightFlow", className: "font-semibold" },
  { name: "CodeHatch", className: "font-mono text-sm" },
  { name: "VertexSoft", className: "font-bold" },
  { name: "NeuralLoop", className: "font-light tracking-wide" },
  { name: "Skybound Tech", className: "font-semibold italic" },
  { name: "InfraZen", className: "font-mono" },
  { name: "Appmint", className: "font-bold tracking-tight" },
  { name: "LogicTrail", className: "font-medium italic" },
  { name: "Corelytics", className: "font-semibold tracking-wide" },
  { name: "Stackory", className: "font-bold uppercase text-sm" },
  { name: "DevSpring", className: "font-medium" },
  { name: "Quantbyte", className: "font-mono tracking-tight" },
  { name: "Softlane", className: "font-light" },
  { name: "Buildora", className: "font-semibold tracking-wide" },
];

const ClientsMarquee = () => {
  return (
    <section className="border-y border-slate-200 bg-white py-10 overflow-hidden">
      <Container>
        <p className="mb-6 text-center text-sm font-semibold uppercase tracking-wide text-slate-500">
          Trusted by growing teams worldwide
        </p>
      </Container>

      {/* Marquee */}
      <div className="relative">
        <div className="flex w-max animate-marquee gap-16 px-8">
          {[...clients, ...clients].map((client, index) => (
            <span
              key={index}
              className={`whitespace-nowrap text-slate-400 hover:text-slate-600 transition ${client.className}`}
            >
              {client.name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsMarquee;
